import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { LibraryQuestionList } from './components/LibraryQuestionList';

export function LibrarySearchPage() {
  const [searchParams] = useSearchParams();
  const query = searchParams.get('q') ?? '';
  return <LibraryQuestionList query={query} />;
}
